








































import { Component, Vue } from 'vue-property-decorator'
import { namespace, Getter, Action } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'

const wallCollectionsStore = namespace('wallCollections')

@Component({
  components: {
    OzIcon,
  },
})
export default class SurfaceNavBookmarkMenuRow extends Vue {
  @Getter showBookmarkFolders!: boolean
  @Action bookmarkWallAndNotify
  @Action openEditBookmarksDialog
  @Action addToFavorites
  @Action removeFromFavorites

  @wallCollectionsStore.Getter isActiveWallBookmarked
  @wallCollectionsStore.Getter isActiveWallInFavorites
}
